import { render, staticRenderFns } from "./TeamData.vue?vue&type=template&id=70ffb9b0"
import script from "./TeamData.vue?vue&type=script&lang=js"
export * from "./TeamData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports